import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '../../auth/context';
import { GenerationFieldOption, GetGenerationFields } from '../api';

/** Empty until auth + org context are ready. Cached 60 s — the catalogue changes rarely. */
export function useGenerationFields(): {
  fields: GenerationFieldOption[];
  isLoading: boolean;
} {
  const { state } = useAuthContext();
  const orgId = state.organization?.id ?? null;

  const { data, isLoading } = useQuery<GenerationFieldOption[]>({
    queryKey: ['generation-fields', orgId],
    queryFn: async () => {
      const { data } = await GetGenerationFields();
      return data;
    },
    staleTime: 60_000,
    enabled: !!orgId,
  });

  return { fields: data ?? [], isLoading };
}
